import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PersonIcon from "@material-ui/icons/Person";
import { OrderDetails_order_events } from "@saleor/motherOrders/types/OrderDetails";
import moment from "moment-timezone";
import React from "react";

import { DateTime } from "../Date";

const useStyles = makeStyles(
  theme => ({
    avatar: {
      left: -45,
      position: "absolute",
      top: 0
    },
    card: {
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(3),
      position: "relative"
    },
    cardContent: {
      "&:last-child": {
        padding: 16
      },
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.05)"
    },
    date: {
      color: theme.typography.caption.color
    },
    root: {
      position: "relative"
    },
    title: {
      "& p": {
        fontSize: "14px"
      },
      display: "flex",
      justifyContent: "space-between",
      marginBottom: theme.spacing(),
      paddingLeft: theme.spacing(3),
      textAlign: "right"
    }
  }),
  { name: "TimelineNoteRemittanceManualAdjust" }
);

interface TimelineNoteRemittanceFlagOrderProps {
  event: OrderDetails_order_events;
  date: string;
  user: {
    email: string;
  };
}

const dateFormat = value => {
  const date = moment(value);
  return date.format("lll");
};

export const TimelineNoteRemittanceManualAdjust: React.FC<TimelineNoteRemittanceFlagOrderProps> = props => {
  const { event, date, user } = props;

  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      {user && (
        <Avatar className={classes.avatar} style={{ background: "#9098A1" }}>
          <PersonIcon />
        </Avatar>
      )}
      <div className={classes.title}>
        <Typography>{user?.email}</Typography>

        <Typography className={classes.date}>
          <Typography>
            <DateTime date={date} />
          </Typography>
          <Typography>{dateFormat(date)}</Typography>
        </Typography>
      </div>

      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Typography>
            {"Manual adjustment amounting to "}
            <b>
              {"Php"}
              {event?.createRemittanceManualAdjustment?.adjustedAmount.toFixed(
                2
              )}
            </b>
          </Typography>

          <Typography>
            {"Reason for adjustment: "}
            {event?.createRemittanceManualAdjustment?.adjustmentReason}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};
TimelineNoteRemittanceManualAdjust.displayName =
  "TimelineNoteRemittanceManualAdjust";
export default TimelineNoteRemittanceManualAdjust;
